(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["contact-modal"] && !Shopify.designMode) return;
  try {
    (() => {
    const initContactModal = () => {
      var modal = document.getElementById('contact-modal');
      if (!modal || modal.dataset.initialized === 'true') return;
      modal.dataset.initialized = 'true';
      modal.style.visibility = '';
      modal.style.opacity = '';

      var openBtns = document.querySelectorAll('[data-open-contact-modal]');
      var closeBtns = modal.querySelectorAll('.contact-modal__close');
      var body = document.body;
      var root = document.documentElement;

      var lockBodyScroll = function() {
        window.__dizianaModalOpenCount = (window.__dizianaModalOpenCount || 0) + 1;
        if (window.__dizianaModalOpenCount === 1) {
          window.__dizianaLockedScrollY = window.scrollY || window.pageYOffset || 0;
          root.style.overflow = 'hidden';
          body.style.overflow = 'hidden';
          body.style.position = 'fixed';
          body.style.top = '-' + window.__dizianaLockedScrollY + 'px';
          body.style.left = '0';
          body.style.right = '0';
          body.style.width = '100%';
          body.style.touchAction = 'none';
        }
      };

      var unlockBodyScroll = function() {
        window.__dizianaModalOpenCount = Math.max((window.__dizianaModalOpenCount || 1) - 1, 0);
        if (window.__dizianaModalOpenCount === 0) {
          var lockedScrollY = window.__dizianaLockedScrollY || 0;
          root.style.overflow = '';
          body.style.overflow = '';
          body.style.position = '';
          body.style.top = '';
          body.style.left = '';
          body.style.right = '';
          body.style.width = '';
          body.style.touchAction = '';
          window.scrollTo(0, lockedScrollY);
          window.__dizianaLockedScrollY = 0;
        }
      };

      var phoneInput = document.getElementById('cm-phone');
      var carouselInitialized = false;

      var scheduleToggle = document.getElementById('cm-schedule-toggle');
      var schedulePanel = document.getElementById('cm-schedule-panel');
      var dateInput = document.getElementById('cm-date');
      var timeInput = document.getElementById('cm-time');
      var phoneStar = document.getElementById('phone-required-star');
      var dateStar = document.getElementById('date-required-star');
      var timeStar = document.getElementById('time-required-star');
      var timezoneStar = document.getElementById('timezone-required-star');
      var orgStar = document.getElementById('org-required-star');
      var orgInput = document.getElementById('cm-organization');

      openBtns.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          if (!modal.classList.contains('contact-modal--open')) {
            lockBodyScroll();
          }
          modal.classList.add('contact-modal--open');
          var isScheduleBtn = btn.textContent.trim().toLowerCase().includes('schedule');
          if (isScheduleBtn && scheduleToggle && !scheduleToggle.checked) {
            scheduleToggle.checked = true;
            scheduleToggle.dispatchEvent(new Event('change'));
          }
          if (!carouselInitialized) {
            carouselInitialized = true;
            var carouselWrap = modal.querySelector('.contact-modal__carousel-wrap');
            if (carouselWrap && window.gsap) {
              var tracks = carouselWrap.querySelectorAll('.contact-modal__carousel-track');
              if (tracks.length) {
                var gap = parseFloat(getComputedStyle(carouselWrap).getPropertyValue('--cm-brand-gap')) || 16;
                var singleTrackWidth = tracks[0].offsetWidth + gap;
                var pixelsPerSecond = 28;
                var duration = singleTrackWidth / pixelsPerSecond;
                var scrollTween = window.gsap.to(tracks, {
                  x: -singleTrackWidth,
                  duration: duration,
                  ease: 'none',
                  repeat: -1,
                });
                carouselWrap.addEventListener('mouseenter', function() { scrollTween.pause(); });
                carouselWrap.addEventListener('mouseleave', function() { scrollTween.play(); });
              }
            }
          }
        });
      });

      closeBtns.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          if (modal.classList.contains('contact-modal--open')) {
            unlockBodyScroll();
          }
          modal.classList.remove('contact-modal--open');
        });
      });

      modal.addEventListener('click', function(e) {
        if (e.target === modal) {
          if (modal.classList.contains('contact-modal--open')) {
            unlockBodyScroll();
          }
          modal.classList.remove('contact-modal--open');
        }
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.classList.contains('contact-modal--open')) {
          unlockBodyScroll();
          modal.classList.remove('contact-modal--open');
        }
      });

      if (scheduleToggle && schedulePanel) {
        scheduleToggle.addEventListener('change', function() {
          if (scheduleToggle.checked) {
            schedulePanel.classList.add('contact-modal__schedule-panel--open');
            if (phoneStar) phoneStar.style.display = 'inline';
            if (dateStar) dateStar.style.display = 'inline';
            if (timeStar) timeStar.style.display = 'inline';
            if (timezoneStar) timezoneStar.style.display = 'inline';
            if (orgStar) orgStar.style.display = 'inline';
            if (phoneInput) phoneInput.setAttribute('required', 'required');
            if (dateInput) dateInput.setAttribute('required', 'required');
            if (timeInput) timeInput.setAttribute('required', 'required');
            if (orgInput) orgInput.setAttribute('required', 'required');
          } else {
            schedulePanel.classList.remove('contact-modal__schedule-panel--open');
            if (phoneStar) phoneStar.style.display = 'none';
            if (dateStar) dateStar.style.display = 'none';
            if (timeStar) timeStar.style.display = 'none';
            if (timezoneStar) timezoneStar.style.display = 'none';
            if (orgStar) orgStar.style.display = 'none';
            if (phoneInput) phoneInput.removeAttribute('required');
            if (dateInput) dateInput.removeAttribute('required');
            if (timeInput) timeInput.removeAttribute('required');
            if (orgInput) orgInput.removeAttribute('required');
          }
        });
      }

      if (dateInput) {
        var today = new Date();
        var yyyy = today.getFullYear();
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var dd = String(today.getDate()).padStart(2, '0');
        dateInput.setAttribute('min', yyyy + '-' + mm + '-' + dd);
      }

      (function() {
        var tzTrigger = document.getElementById('cm-tz-trigger');
        var tzDropdown = document.getElementById('cm-tz-dropdown');
        var tzSearch = document.getElementById('cm-tz-search');
        var tzList = document.getElementById('cm-tz-list');
        var tzName = document.getElementById('cm-tz-name');
        var tzAbbr = document.getElementById('cm-tz-abbr');
        var tzCaret = document.getElementById('cm-tz-caret');
        var tzHidden = document.getElementById('cm-timezone');
        if (!tzTrigger || !tzDropdown) return;

        var allTimezones = [];
        var selectedTimezone = '';

        function getTzOffset(tz) {
          var now = new Date();
          var utcStr = now.toLocaleString('en', { timeZone: 'UTC' });
          var tzStr = now.toLocaleString('en', { timeZone: tz });
          var diff = new Date(tzStr) - new Date(utcStr);
          var offsetMin = diff / 60000;
          var sign = offsetMin >= 0 ? '+' : '-';
          var absMin = Math.abs(offsetMin);
          var h = Math.floor(absMin / 60);
          var m = Math.floor(absMin % 60);
          return sign + String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0');
        }

        function getTzDisplay(tz) {
          var parts = Intl.DateTimeFormat('en', { timeZone: tz, timeZoneName: 'short' }).formatToParts(new Date());
          var abbr = (parts.find(function(p) { return p.type === 'timeZoneName'; }) || {}).value || '';
          var offset = getTzOffset(tz);
          return /^GMT[+-]?\d/.test(abbr) ? 'GMT ' + offset : abbr + ' ' + offset;
        }

        function buildList() {
          allTimezones = Intl.supportedValuesOf('timeZone').map(function(tz) {
            return {
              tz: tz,
              display: getTzDisplay(tz),
              search: (tz + ' ' + getTzDisplay(tz)).toLowerCase()
            };
          });
        }

        function renderList(filter) {
          tzList.innerHTML = '';
          var items = filter ? allTimezones.filter(function(o) { return o.search.includes(filter.toLowerCase()); }) : allTimezones;
          items.forEach(function(o) {
            var div = document.createElement('div');
            div.className = 'contact-modal__tz-option' + (o.tz === selectedTimezone ? ' contact-modal__tz-option--selected' : '');
            div.innerHTML = '<span>' + o.tz + '</span><span class="contact-modal__tz-offset">' + o.display + '</span>';
            div.addEventListener('click', function() { selectTz(o.tz); });
            tzList.appendChild(div);
          });
        }

        function selectTz(tz) {
          selectedTimezone = tz;
          tzName.textContent = tz;
          tzAbbr.textContent = getTzDisplay(tz);
          tzAbbr.className = 'contact-modal__tz-abbr contact-modal__tz-abbr--manual';
          if (tzHidden) tzHidden.value = tz;
          closeDropdown();
        }

        function openDropdown() {
          tzDropdown.classList.add('contact-modal__tz-dropdown--open');
          tzTrigger.classList.add('contact-modal__tz-trigger--open');
          tzCaret.classList.add('contact-modal__tz-caret--open');
          renderList('');
          tzSearch.value = '';
          if (tzSearch) {
            try {
              tzSearch.focus({ preventScroll: true });
            } catch (error) {
              tzSearch.focus();
            }
          }
          setTimeout(function() {
            var sel = tzList.querySelector('.contact-modal__tz-option--selected');
            if (!sel || !tzList) return;
            var optionTop = sel.offsetTop;
            var optionHeight = sel.offsetHeight;
            var listHeight = tzList.clientHeight;
            tzList.scrollTop = optionTop - ((listHeight - optionHeight) / 2);
          }, 50);
        }

        function closeDropdown() {
          tzDropdown.classList.remove('contact-modal__tz-dropdown--open');
          tzTrigger.classList.remove('contact-modal__tz-trigger--open');
          tzCaret.classList.remove('contact-modal__tz-caret--open');
        }

        tzTrigger.addEventListener('click', function(e) {
          e.stopPropagation();
          if (tzDropdown.classList.contains('contact-modal__tz-dropdown--open')) {
            closeDropdown();
          } else {
            openDropdown();
          }
        });

        if (tzSearch) {
          tzSearch.addEventListener('input', function() { renderList(this.value); });
        }

        document.addEventListener('click', function(e) {
          var wrapper = document.getElementById('cm-tz-combo');
          if (wrapper && !wrapper.contains(e.target)) closeDropdown();
        });

        buildList();
        var detected = Intl.DateTimeFormat().resolvedOptions().timeZone;
        selectedTimezone = detected;
        tzName.textContent = detected;
        tzAbbr.textContent = getTzDisplay(detected);
        tzAbbr.className = 'contact-modal__tz-abbr contact-modal__tz-abbr--auto';
        if (tzHidden) tzHidden.value = detected;
      })();

      (function() {
        var stack = document.getElementById('cm-testimonial-stack');
        if (!stack) return;

        var cards = Array.from(stack.querySelectorAll('.contact-modal__testimonial-card'));
        if (cards.length < 2) return;

        var dragging = false;
        var startX = 0;
        var currentX = 0;
        var autoInterval = null;

        function updateStack(offsetX) {
          cards.forEach(function(card, i) {
            card.style.zIndex = cards.length - i;
            var stackX = i * 6;
            var stackY = i * 14;
            var s = 1 - i * 0.05;
            var t;
            if (i === 0) {
              var dragX = offsetX || 0;
              t = 'translate(' + dragX + 'px, 0px) scale(1)';
            } else {
              t = 'translate(' + stackX + 'px, ' + stackY + 'px) scale(' + s + ')';
            }
            card.style.transform = t;
            card.style.opacity = i === cards.length - 1 ? 0 : 1;
          });
        }

        function nextCard() {
          var last = cards.pop();
          cards.unshift(last);
          updateStack(0);
        }

        function prevCard() {
          var first = cards.shift();
          cards.push(first);
          updateStack(0);
        }

        function startAuto() {
          stopAuto();
          autoInterval = setInterval(nextCard, 3500);
        }

        function stopAuto() {
          if (autoInterval) {
            clearInterval(autoInterval);
            autoInterval = null;
          }
        }

        stack.addEventListener('pointerdown', function(e) {
          if (e.target.closest('button, a')) return;
          dragging = true;
          startX = e.clientX;
          currentX = 0;
          stopAuto();
          stack.style.cursor = 'grabbing';
          stack.setPointerCapture(e.pointerId);
        });

        stack.addEventListener('pointermove', function(e) {
          if (!dragging) return;
          currentX = e.clientX - startX;
          updateStack(currentX);
        });

        stack.addEventListener('pointerup', function() {
          if (!dragging) return;
          dragging = false;
          stack.style.cursor = 'grab';
          if (Math.abs(currentX) > 60) {
            if (currentX > 0) {
              prevCard();
            } else {
              nextCard();
            }
          } else {
            updateStack(0);
          }
          currentX = 0;
          startAuto();
        });

        stack.addEventListener('pointerleave', function() {
          if (dragging) {
            dragging = false;
            stack.style.cursor = 'grab';
            updateStack(0);
            currentX = 0;
            startAuto();
          }
        });

        updateStack(0);
        startAuto();
      })();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initContactModal, { once: true });
    } else {
      initContactModal();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gen2-sonner"] && !Shopify.designMode) return;
  try {
    (() => {
    const sonner = document.querySelector('[data-gen2-sonner]');

    if (!sonner) {
      return;
    }

    const storageKey = 'gen2-sonner-dismissed';
    const articleId = sonner.getAttribute('data-article-id');
    const closeButton = sonner.querySelector('[data-gen2-sonner-close]');

    try {
      const dismissedValue = window.localStorage.getItem(storageKey);

      if (dismissedValue && dismissedValue === articleId) {
        return;
      }
    } catch (error) {
    }

    const revealSonner = () => {
      sonner.hidden = false;

      window.requestAnimationFrame(() => {
        sonner.classList.add('is-visible');
      });
    };

    window.setTimeout(revealSonner, 1400);

    closeButton.addEventListener('click', () => {
      sonner.classList.remove('is-visible');

      window.setTimeout(() => {
        sonner.hidden = true;
      }, 240);

      try {
        window.localStorage.setItem(storageKey, articleId);
      } catch (error) {
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["phone-country-field"] && !Shopify.designMode) return;
  try {
    (function() {
    if (!window.DizianaPhoneField) {
      window.DizianaPhoneField = (function() {
        var rawCountries = [["af","93",0],["ax","358",1],["al","355",0],["dz","213",0],["as","1",5],["ad","376",0],["ao","244",0],["ai","1",6],["ag","1",7],["ar","54",0],["am","374",0],["aw","297",0],["ac","247",0],["au","61",0],["at","43",0],["az","994",0],["bs","1",8],["bh","973",0],["bd","880",0],["bb","1",9],["by","375",0],["be","32",0],["bz","501",0],["bj","229",0],["bm","1",10],["bt","975",0],["bo","591",0],["ba","387",0],["bw","267",0],["br","55",0],["io","246",0],["vg","1",11],["bn","673",0],["bg","359",0],["bf","226",0],["bi","257",0],["kh","855",0],["cm","237",0],["ca","1",1],["cv","238",0],["bq","599",1],["ky","1",12],["cf","236",0],["td","235",0],["cl","56",0],["cn","86",0],["cx","61",2],["cc","61",1],["co","57",0],["km","269",0],["cg","242",0],["cd","243",0],["ck","682",0],["cr","506",0],["ci","225",0],["hr","385",0],["cu","53",0],["cw","599",0],["cy","357",0],["cz","420",0],["dk","45",0],["dj","253",0],["dm","1",13],["do","1",2],["ec","593",0],["eg","20",0],["sv","503",0],["gq","240",0],["er","291",0],["ee","372",0],["sz","268",0],["et","251",0],["fk","500",0],["fo","298",0],["fj","679",0],["fi","358",0],["fr","33",0],["gf","594",0],["pf","689",0],["ga","241",0],["gm","220",0],["ge","995",0],["de","49",0],["gh","233",0],["gi","350",0],["gr","30",0],["gl","299",0],["gd","1",14],["gp","590",0],["gu","1",15],["gt","502",0],["gg","44",1],["gn","224",0],["gw","245",0],["gy","592",0],["ht","509",0],["hn","504",0],["hk","852",0],["hu","36",0],["is","354",0],["in","91",0],["id","62",0],["ir","98",0],["iq","964",0],["ie","353",0],["im","44",2],["il","972",0],["it","39",0],["jm","1",4],["jp","81",0],["je","44",3],["jo","962",0],["kz","7",1],["ke","254",0],["ki","686",0],["xk","383",0],["kw","965",0],["kg","996",0],["la","856",0],["lv","371",0],["lb","961",0],["ls","266",0],["lr","231",0],["ly","218",0],["li","423",0],["lt","370",0],["lu","352",0],["mo","853",0],["mg","261",0],["mw","265",0],["my","60",0],["mv","960",0],["ml","223",0],["mt","356",0],["mh","692",0],["mq","596",0],["mr","222",0],["mu","230",0],["yt","262",1],["mx","52",0],["fm","691",0],["md","373",0],["mc","377",0],["mn","976",0],["me","382",0],["ms","1",16],["ma","212",0],["mz","258",0],["mm","95",0],["na","264",0],["nr","674",0],["np","977",0],["nl","31",0],["nc","687",0],["nz","64",0],["ni","505",0],["ne","227",0],["ng","234",0],["nu","683",0],["nf","672",0],["kp","850",0],["mk","389",0],["mp","1",17],["no","47",0],["om","968",0],["pk","92",0],["pw","680",0],["ps","970",0],["pa","507",0],["pg","675",0],["py","595",0],["pe","51",0],["ph","63",0],["pl","48",0],["pt","351",0],["pr","1",3],["qa","974",0],["re","262",0],["ro","40",0],["ru","7",0],["rw","250",0],["ws","685",0],["sm","378",0],["st","239",0],["sa","966",0],["sn","221",0],["rs","381",0],["sc","248",0],["sl","232",0],["sg","65",0],["sx","1",21],["sk","421",0],["si","386",0],["sb","677",0],["so","252",0],["za","27",0],["kr","82",0],["ss","211",0],["es","34",0],["lk","94",0],["bl","590",1],["sh","290",0],["kn","1",18],["lc","1",19],["mf","590",2],["pm","508",0],["vc","1",20],["sd","249",0],["sr","597",0],["sj","47",1],["se","46",0],["ch","41",0],["sy","963",0],["tw","886",0],["tj","992",0],["tz","255",0],["th","66",0],["tl","670",0],["tg","228",0],["tk","690",0],["to","676",0],["tt","1",22],["tn","216",0],["tr","90",0],["tm","993",0],["tc","1",23],["tv","688",0],["vi","1",24],["ug","256",0],["ua","380",0],["ae","971",0],["gb","44",0],["us","1",0],["uy","598",0],["uz","998",0],["vu","678",0],["va","39",1],["ve","58",0],["vn","84",0],["wf","681",0],["eh","212",1],["ye","967",0],["zm","260",0],["zw","263",0]];
        var nameOverrides = { ac: 'Ascension Island', ci: "Cote d'Ivoire", hk: 'Hong Kong', mo: 'Macao', ps: 'Palestine', xk: 'Kosovo' };
        var displayNames = null;
        if (window.Intl && typeof Intl.DisplayNames === 'function') {
          try {
            displayNames = new Intl.DisplayNames(['en'], { type: 'region' });
          } catch (error) {}
        }
        function getCountryName(iso2) {
          if (nameOverrides[iso2]) return nameOverrides[iso2];
          if (displayNames) {
            try {
              return displayNames.of(iso2.toUpperCase());
            } catch (error) {}
          }
          return iso2.toUpperCase();
        }
        function getFlagEmoji(iso2) {
          if (iso2 === 'xk') return '🇽🇰';
          if (iso2.length !== 2) return '🌐';
          return iso2.toUpperCase().split('').map(function(char) {
            return String.fromCodePoint(127397 + char.charCodeAt(0));
          }).join('');
        }
        var countries = rawCountries.map(function(entry) {
          return { iso2: entry[0], dialCode: entry[1], priority: entry[2] || 0, name: getCountryName(entry[0]), flag: getFlagEmoji(entry[0]) };
        }).sort(function(a, b) {
          var nameCompare = a.name.localeCompare(b.name);
          if (nameCompare !== 0) return nameCompare;
          if (a.dialCode !== b.dialCode) return Number(a.dialCode) - Number(b.dialCode);
          return a.priority - b.priority;
        });
        var countriesByIso2 = new Map(countries.map(function(country) {
          return [country.iso2, country];
        }));
        function detectCountry(fallbackIso2) {
          var detectedIso2 = fallbackIso2;
          var timezoneCountryMap = {
            'Europe/London': 'gb',
            'Europe/Dublin': 'ie',
            'Europe/Berlin': 'de',
            'Europe/Paris': 'fr',
            'Europe/Madrid': 'es',
            'Europe/Rome': 'it',
            'Europe/Amsterdam': 'nl',
            'Europe/Brussels': 'be',
            'Europe/Zurich': 'ch',
            'Europe/Vienna': 'at',
            'Europe/Stockholm': 'se',
            'Europe/Oslo': 'no',
            'Europe/Copenhagen': 'dk',
            'Europe/Helsinki': 'fi',
            'Europe/Warsaw': 'pl',
            'Europe/Prague': 'cz',
            'Europe/Budapest': 'hu',
            'Europe/Athens': 'gr',
            'Europe/Bucharest': 'ro',
            'Europe/Sofia': 'bg',
            'Europe/Kyiv': 'ua',
            'Europe/Istanbul': 'tr',
            'Europe/Moscow': 'ru',
            'Asia/Dubai': 'ae',
            'Asia/Calcutta': 'in',
            'Asia/Kolkata': 'in',
            'Asia/Karachi': 'pk',
            'Asia/Dhaka': 'bd',
            'Asia/Kathmandu': 'np',
            'Asia/Colombo': 'lk',
            'Asia/Bangkok': 'th',
            'Asia/Singapore': 'sg',
            'Asia/Kuala_Lumpur': 'my',
            'Asia/Jakarta': 'id',
            'Asia/Manila': 'ph',
            'Asia/Hong_Kong': 'hk',
            'Asia/Tokyo': 'jp',
            'Asia/Seoul': 'kr',
            'Asia/Shanghai': 'cn',
            'Asia/Taipei': 'tw',
            'Australia/Sydney': 'au',
            'Australia/Melbourne': 'au',
            'Australia/Perth': 'au',
            'Pacific/Auckland': 'nz',
            'Africa/Lagos': 'ng',
            'Africa/Nairobi': 'ke',
            'Africa/Johannesburg': 'za',
            'Africa/Cairo': 'eg',
            'America/New_York': 'us',
            'America/Chicago': 'us',
            'America/Denver': 'us',
            'America/Los_Angeles': 'us',
            'America/Phoenix': 'us',
            'America/Toronto': 'ca',
            'America/Vancouver': 'ca',
            'America/Mexico_City': 'mx',
            'America/Sao_Paulo': 'br'
          };
          var timezone = '';
          var timezoneMatched = false;

          if (window.Intl && Intl.DateTimeFormat) {
            try {
              timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
            } catch (error) {}
          }

          if (timezone && timezoneCountryMap[timezone] && countriesByIso2.has(timezoneCountryMap[timezone])) {
            detectedIso2 = timezoneCountryMap[timezone];
            timezoneMatched = true;
          }

          if (!timezoneMatched && window.navigator) {
            var locales = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
            locales.some(function(locale) {
              if (!locale) return false;
              var parts = locale.split('-');
              var candidate = parts[parts.length - 1];
              if (candidate && candidate.length === 2) {
                candidate = candidate.toLowerCase();
                if (countriesByIso2.has(candidate)) {
                  detectedIso2 = candidate;
                  return true;
                }
              }
              return false;
            });
          }
          return countriesByIso2.get(detectedIso2) || countriesByIso2.get('us') || countries[0];
        }
        function cleanLocalNumber(value) {
          return value.replace(/[^\d]/g, '').slice(0, 18);
        }
        function buildSearchValue(country) {
          return [country.name, country.iso2, '+' + country.dialCode, country.dialCode].join(' ').toLowerCase();
        }
        function syncValue(state) {
          var cleaned = cleanLocalNumber(state.input.value);
          if (state.input.value !== cleaned) state.input.value = cleaned;
          state.inlineCode.textContent = '+' + state.selected.dialCode;
          state.flag.textContent = state.selected.flag;
          state.toggle.setAttribute('aria-label', state.inputLabel + ', ' + state.selected.name + ' +' + state.selected.dialCode);
          state.hiddenCountryCode.value = '+' + state.selected.dialCode;
          state.hiddenCountryIso2.value = state.selected.iso2;
          state.hiddenPhone.value = cleaned ? '+' + state.selected.dialCode + ' ' + cleaned : '';
        }
        function closeAll(exceptRoot) {
          document.querySelectorAll('[data-phone-field][data-phone-open="true"]').forEach(function(root) {
            if (exceptRoot && root === exceptRoot) return;
            root.dataset.phoneOpen = 'false';
            var toggle = root.querySelector('[data-phone-toggle]');
            var dropdown = root.querySelector('[data-phone-dropdown]');
            if (toggle) toggle.setAttribute('aria-expanded', 'false');
            if (dropdown) dropdown.hidden = true;
          });
        }
        function renderResults(state, query) {
          var normalized = query.trim().toLowerCase();
          var matches = countries.filter(function(country) {
            return buildSearchValue(country).indexOf(normalized) !== -1;
          });
          state.results.innerHTML = '';
          if (!matches.length) {
            state.results.innerHTML = '<div class="dz-phone-field__empty">No countries found.</div>';
            return;
          }
          matches.forEach(function(country) {
            var option = document.createElement('button');
            option.type = 'button';
            option.className = 'dz-phone-field__option' + (country.iso2 === state.selected.iso2 ? ' dz-phone-field__option--selected' : '');
            option.dataset.iso2 = country.iso2;
            option.setAttribute('role', 'option');
            option.setAttribute('aria-selected', country.iso2 === state.selected.iso2 ? 'true' : 'false');
            option.innerHTML = '<span class="dz-phone-field__option-flag" aria-hidden="true">' + country.flag + '</span><span class="dz-phone-field__option-name">' + country.name + '</span><span class="dz-phone-field__option-code">+' + country.dialCode + '</span><span class="dz-phone-field__option-check" aria-hidden="true">✓</span>';
            state.results.appendChild(option);
          });
        }
        function selectCountry(state, iso2) {
          var nextCountry = countriesByIso2.get(iso2);
          if (!nextCountry) return;
          state.selected = nextCountry;
          syncValue(state);
          renderResults(state, state.search.value);
        }
        function openDropdown(state) {
          closeAll(state.root);
          state.root.dataset.phoneOpen = 'true';
          state.dropdown.hidden = false;
          state.toggle.setAttribute('aria-expanded', 'true');
          renderResults(state, state.search.value);
          try {
            state.search.focus({ preventScroll: true });
          } catch (error) {
            state.search.focus();
          }
        }
        function closeDropdown(state) {
          state.root.dataset.phoneOpen = 'false';
          state.dropdown.hidden = true;
          state.toggle.setAttribute('aria-expanded', 'false');
        }
        function bindForm(root) {
          var form = root.closest('form');
          if (!form || form.dataset.phoneFieldBound === 'true') return;
          form.dataset.phoneFieldBound = 'true';
          form.addEventListener('submit', function() {
            form.querySelectorAll('[data-phone-field]').forEach(function(fieldRoot) {
              var localInput = fieldRoot.querySelector('[data-phone-local-input]');
              var hiddenPhone = fieldRoot.querySelector('[data-phone-full-number]');
              var hiddenCountryCode = fieldRoot.querySelector('[data-phone-country-code]');
              if (localInput && hiddenPhone && hiddenCountryCode && hiddenPhone.value === '' && localInput.value !== '') {
                hiddenPhone.value = hiddenCountryCode.value + ' ' + cleanLocalNumber(localInput.value);
              }
            });
          });
        }
        function initField(root) {
          if (!root || root.dataset.phoneFieldReady === 'true') return;
          var toggle = root.querySelector('[data-phone-toggle]');
          var dropdown = root.querySelector('[data-phone-dropdown]');
          var search = root.querySelector('[data-phone-search]');
          var results = root.querySelector('[data-phone-results]');
          var input = root.querySelector('[data-phone-local-input]');
          var hiddenPhone = root.querySelector('[data-phone-full-number]');
          var hiddenCountryCode = root.querySelector('[data-phone-country-code]');
          var hiddenCountryIso2 = root.querySelector('[data-phone-country-iso2]');
          var inlineCode = root.querySelector('[data-phone-inline-code]');
          var flag = root.querySelector('[data-phone-flag]');
          if (!toggle || !dropdown || !search || !results || !input || !hiddenPhone || !hiddenCountryCode || !hiddenCountryIso2 || !inlineCode || !flag) return;
          var label = root.querySelector('label');
          var state = {
            root: root,
            toggle: toggle,
            dropdown: dropdown,
            search: search,
            results: results,
            input: input,
            hiddenPhone: hiddenPhone,
            hiddenCountryCode: hiddenCountryCode,
            hiddenCountryIso2: hiddenCountryIso2,
            inlineCode: inlineCode,
            flag: flag,
            inputLabel: label ? label.textContent.trim() : 'Phone number',
            selected: detectCountry((root.dataset.defaultCountry || 'us').toLowerCase())
          };
          root.dataset.phoneFieldReady = 'true';
          root.dataset.phoneOpen = 'false';
          syncValue(state);
          bindForm(root);
          toggle.addEventListener('click', function() {
            if (root.dataset.phoneOpen === 'true') {
              closeDropdown(state);
            } else {
              openDropdown(state);
            }
          });
          search.addEventListener('input', function() {
            renderResults(state, search.value);
          });
          results.addEventListener('click', function(event) {
            var option = event.target.closest('.dz-phone-field__option');
            if (!option) return;
            selectCountry(state, option.dataset.iso2);
            closeDropdown(state);
            try {
              input.focus({ preventScroll: true });
            } catch (error) {
              input.focus();
            }
          });
          input.addEventListener('input', function() {
            syncValue(state);
          });
          input.addEventListener('blur', function() {
            syncValue(state);
          });
          root.addEventListener('keydown', function(event) {
            if (event.key === 'Escape') closeDropdown(state);
          });
        }
        function init(scope) {
          var container = scope && scope.querySelectorAll ? scope : document;
          container.querySelectorAll('[data-phone-field]').forEach(initField);
        }
        document.addEventListener('click', function(event) {
          var activeField = event.target.closest('[data-phone-field]');
          closeAll(activeField);
        });
        document.addEventListener('shopify:section:load', function(event) {
          init(event.target);
        });
        return { init: init };
      })();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        window.DizianaPhoneField.init(document);
      });
    } else {
      window.DizianaPhoneField.init(document);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
